import { RenalDetectRecommendation } from '@app/core/models';
import { AllowanceParams } from '@app/pages/allowance/allowance';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsultationState } from './consultation.state';

export const selectConsultation = createFeatureSelector<ConsultationState>(StateNamesEnum.CONSULTATION_STATE_NAME);

export const selectConsultationPatient = createSelector(selectConsultation, (state: ConsultationState) => state.patient);
export const selectConsultationPetOwner = createSelector(selectConsultation, (state: ConsultationState) => state.petOwner);
export const selectConsultationRenalDetectRecommendation = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.renalDetectRecommendation
);
export const selectConsultationRenalDetectNutritionalChoice = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.renalDetectNutritionalChoice
);
export const selectConsultationRenalDetectPrediction = createSelector(
  selectConsultationRenalDetectRecommendation,
  (recommendation: RenalDetectRecommendation) => recommendation?.prediction
);
export const selectConsultationLastConsultation = createSelector(selectConsultation, (state: ConsultationState) => state.lastConsultation);
export const selectConsultationCurrentConsultation = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.currentConsultation
);

export const selectConsultationAllowanceParams = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.allowanceParams || ({} as AllowanceParams)
);

export const selectConsultationCreatingConsultation = createSelector(
  selectConsultation,
  (state: ConsultationState) => state.creatingCurrentConsultation
);

export const selectConsultationSkipProductBook = createSelector(selectConsultation, (state: ConsultationState) => state.skipProductBook);
